module.exports = __webpack_public_path__ + "static/media/Delivery Of medicine.5ca44c41.png";